const languageOptions = [
    // { label: "Afrikaans - Suid-Afrika", value: "af-ZA" },
    // { label: "العربية", value: "ar-XA" },
    // { label: "বাংলা - ভারত", value: "bn-IN" },
    // { label: "Български - България", value: "bg-BG" },
    // { label: "Català - Espanya", value: "ca-ES" },
    // { label: "普通话 - 中国大陆", value: "cmn-CN" },
    // { label: "國語 - 台灣", value: "cmn-TW" },
    // { label: "廣東話 - 香港", value: "yue-HK" },
    // { label: "Čeština - Česká republika", value: "cs-CZ" },
    // { label: "Dansk - Danmark", value: "da-DK" },
    // { label: "Nederlands - België", value: "nl-BE" },
    // { label: "Nederlands - Nederland", value: "nl-NL" },
    // { label: "English - Australia", value: "en-AU" },
    // { label: "English - United Kingdom", value: "en-GB" },
    // { label: "English - India", value: "en-IN" },
    { label: "English", value: "en-US" },
    // { label: "Español - Espanya", value: "es-ES" },
    // { label: "Español - Estados Unidos", value: "es-US" },
    // { label: "Filipino - Pilipinas", value: "fil-PH" },
    // { label: "Suomi - Suomi", value: "fi-FI" },
    // { label: "Français - Canada", value: "fr-CA" },
    { label: "Français", value: "fr-FR" },
    // { label: "Deutsch - Deutschland", value: "de-DE" },
    // { label: "Ελληνικά - Ελλάδα", value: "el-GR" },
    // { label: "ગુજરાતી - ભારત", value: "gu-IN" },
    // { label: "עברית - ישראל", value: "he-IL" },
    // { label: "हिन्दी - भारत", value: "hi-IN" },
    // { label: "Magyar - Magyarország", value: "hu-HU" },
    // { label: "Íslenska - Ísland", value: "is-IS" },
    // { label: "Bahasa Indonesia - Indonesia", value: "id-ID" },
    // { label: "Italiano - Italia", value: "it-IT" },
    // { label: "日本語 - 日本", value: "ja-JP" },
    // { label: "ಕನ್ನಡ - ಭಾರತ", value: "kn-IN" },
    // { label: "한국어 - 대한민국", value: "ko-KR" },
    // { label: "Latviešu - Latvija", value: "lv-LV" },
    // { label: "Lietuvių - Lietuva", value: "lt-LT" },
    // { label: "Bahasa Melayu - Malaysia", value: "ms-MY" },
    // { label: "മലയാളം - ഇന്ത്യ", value: "ml-IN" },
    // { label: "मराठी - भारत", value: "mr-IN" },
    // { label: "Norsk Bokmål - Norge", value: "nb-NO" },
    // { label: "Polski - Polska", value: "pl-PL" },
    // { label: "Português - Brasil", value: "pt-BR" },
    // { label: "Português - Portugal", value: "pt-PT" },
    // { label: "ਪੰਜਾਬੀ - ਭਾਰਤ", value: "pa-IN" },
    // { label: "Română - România", value: "ro-RO" },
    // { label: "Русский - Россия", value: "ru-RU" },
    // { label: "Српски - Србија", value: "sr-RS" },
    // { label: "Slovenčina - Slovensko", value: "sk-SK" },
    // { label: "Svenska - Sverige", value: "sv-SE" },
    // { label: "தமிழ் - இந்தியா", value: "ta-IN" },
    // { label: "తెలుగు - భారతదేశం", value: "te-IN" },
    // { label: "ไทย - ประเทศไทย", value: "th-TH" },
    // { label: "Türkçe - Türkiye", value: "tr-TR" },
    // { label: "Українська - Україна", value: "uk-UA" },
    // { label: "Tiếng Việt - Việt Nam", value: "vi-VN" },
];

export default languageOptions;
